import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TermKeyword from '../term-keyword/termKeyword';
import TermVolume from '../term-volume/termVolume';

import './packTerm.css';

export default class PackTerm extends Component {

    render() {
      return (<div className='pack-term' style={{backgroundImage: `url(http://api.higherlowergame.com/_client/images/general/${this.props.term.image.replace("'", "%27")})`}}>
        <div className={this.props.termType === 'current' ? 'pack-term__wrapper pack-term__wrapper--current' : 'pack-term__wrapper'}>
          <TermKeyword keyword={this.props.term.keyword} />
          <TermVolume volume={this.props.term.searchVolume} hidden={this.props.termType === 'current'} />
        </div>
        <a rel='nofollow noopener noreferrer' target='_blank' className='pack-term__attribution' href={this.props.term.link}>Image: {this.props.term.author}</a>
      </div>);
    }
}

PackTerm.propTypes = {
  termType: PropTypes.string, 
  term: PropTypes.object
}


// WEBPACK FOOTER //
// ./src/components/pack-term/packTerm.js